import * as React from "react";
import StatAttribute from "../StatAttribute/StatAttribute";

function toValuesList(value, newValue, separator, reverse) {
        let ATTRIBUTE_VALUE_CLASS = "tank-config_value";
        let ATTRIBUTE_VALUE_UP_CLASS = ATTRIBUTE_VALUE_CLASS + "__up",
            ATTRIBUTE_VALUE_DOWN_CLASS = ATTRIBUTE_VALUE_CLASS + "__down";

        let currentValuesList = Array.isArray(value) ? value : [value];
        let newValuesList = Array.isArray(newValue) ? newValue : [newValue];
        let attributeValuesList = [];

        currentValuesList.map((v,i) => {
            // (0.1 + 0.2 == 0.3) --> false in javascript
            // so we add 0.0001 for scaling
            let newStat = Math.round((newValuesList[i] + 0.00001) * 100) / 100;
            let value = Math.round((v + 0.00001) * 100) / 100;
            let abs_newStat = Math.abs(newStat);
            let abs_value = Math.abs(value);
            let currentStat;
            let ROUND_CLASS = ATTRIBUTE_VALUE_CLASS;
            if (newStat) {
                // compare using absolute values only
                if ((abs_value > abs_newStat && !(reverse)) || (abs_value < abs_newStat && reverse))
                    ROUND_CLASS += " " + ATTRIBUTE_VALUE_DOWN_CLASS;
                if ((abs_value < abs_newStat && !(reverse)) || (abs_value > abs_newStat && reverse))
                    ROUND_CLASS += " " + ATTRIBUTE_VALUE_UP_CLASS;
                currentStat = newStat;
            } else {
                currentStat = value;
            }
            attributeValuesList.push(<span className={ROUND_CLASS} key={i}>{currentStat}</span>);
            if (i !== currentValuesList.length-1)
                attributeValuesList.push(separator);
        });
        return attributeValuesList;
    };

export default class StatSection extends React.Component {

    render() {
        let ARROW_CLASS = "tank-config_arrow";
        let TITLE_CLASS = "tank-config_title";
        let TITLE_ICON_CLASS = "tank-config_title-icon";
        const componentData = this.props.componentData;

        if (componentData.value !== componentData.newValue) {
            if (componentData.value < componentData.newValue) {
                ARROW_CLASS += " " + ARROW_CLASS + "__up";
                TITLE_CLASS += " " + TITLE_CLASS + "__up";
                TITLE_ICON_CLASS += " " + TITLE_ICON_CLASS + "__up";
            } else {
                ARROW_CLASS += " " + ARROW_CLASS + "__down";
                TITLE_CLASS += " " + TITLE_CLASS + "__down";
                TITLE_ICON_CLASS += " " + TITLE_ICON_CLASS + "__down";
            }
        }

        return (
            <div className="tank-config tank-config__stat">
                {/* <div className="tank-config_header">*/}
                {/*     <span className={TITLE_ICON_CLASS}>*/}
                {/*         <span className="svg-icon js-svg-icon"*/}
                {/*               data-src={ STATIC_URL +"tankopedia/img/svg-icons/" + this.props.icon + "_icon.svg"}>*/}
                {/*         </span>*/}
                {/*     </span>*/}
                {/*     <div className={TITLE_CLASS}>{this.props.title}</div>*/}
                {/*     <span className={ARROW_CLASS}>*/}
                {/*         <span className="svg-icon js-svg-icon"*/}
                {/*               data-src={ STATIC_URL +"tankopedia/img/svg-icons/double_arrow.svg"}>*/}
                {/*         </span>*/}
                {/*     </span>*/}
                {/*</div>*/}
                <div className="tank-config_details key-statistic">
                    <div className="tank-config_details_corner"></div>
                    <span className="tank-config_item-values key-statistic">{this.props.title.toUpperCase()}</span>
                    <span className="tank-config_item-values key-statistic_value">
                        {toValuesList(componentData.value, componentData.newValue, componentData.separator, componentData.reverse)}
                    </span>
                    <span className="tank-config_item-values key-statistic_unit">{componentData.unit.toUpperCase()}</span>
                </div>
            </div>
        )
    }
}